import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";

const Overview = lazy(() =>
  import("./pages/Overview").then((mod) => ({ default: mod.Overview })),
);
const Distribution = lazy(() =>
  import("./pages/Distribution").then((mod) => ({
    default: mod.Distribution,
  })),
);
const GameAnalysis = lazy(() =>
  import("./pages/GameAnalysis").then((mod) => ({
    default: mod.GameAnalysis,
  })),
);
const Devices = lazy(() =>
  import("./pages/Devices").then((mod) => ({ default: mod.Devices })),
);
const DeathLocations = lazy(() =>
  import("./pages/DeathLocations").then((mod) => ({ default: mod.DeathLocations })),
);
const Detections = lazy(() =>
  import("./pages/Detections").then((mod) => ({ default: mod.Detections })),
);
const Sessions = lazy(() =>
  import("./pages/Sessions").then((mod) => ({ default: mod.Sessions })),
);
const SessionDetail = lazy(() =>
  import("./pages/SessionDetail").then((mod) => ({
    default: mod.SessionDetail,
  })),
);

const DbOverview = lazy(() => import("./pages/db/DbOverview").then((mod) => ({ default: mod.DbOverview })));
const DbBalance = lazy(() => import("./pages/db/DbBalance").then((mod) => ({ default: mod.DbBalance })));
const DbRoles = lazy(() => import("./pages/db/DbRoles").then((mod) => ({ default: mod.DbRoles })));
const DbMatches = lazy(() => import("./pages/db/DbMatches").then((mod) => ({ default: mod.DbMatches })));
const DbMatchDetail = lazy(() => import("./pages/db/DbMatchDetail").then((mod) => ({ default: mod.DbMatchDetail })));

export default function App() {
  return (
    <Suspense fallback={<div className="loading">Loading...</div>}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Overview />} />
          <Route path="distribution" element={<Distribution />} />
          <Route path="analysis" element={<GameAnalysis />} />
          <Route path="devices" element={<Devices />} />
          <Route path="death-locations" element={<DeathLocations />} />
          <Route path="detections" element={<Detections />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="sessions/:id" element={<SessionDetail />} />
          {/* Double Blind — HAS 와 완전히 분리된 영역 */}
          <Route path="db" element={<DbOverview />} />
          <Route path="db/balance" element={<DbBalance />} />
          <Route path="db/roles" element={<DbRoles />} />
          <Route path="db/matches" element={<DbMatches />} />
          <Route path="db/matches/:id" element={<DbMatchDetail />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
